import React from "react";
import { Stack, IconButton, Typography } from "@mui/material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import { Utils } from "utils";

interface CounterProps {
  value: number;
  minValue: number;
  maxValue: number;
  onReduce: () => void;
  onIncrease: () => void;
  variant: "number" | "time";
}

export const Counter = ({
  value,
  variant,
  maxValue,
  minValue,
  onReduce,
  onIncrease,
}: CounterProps) => {
  const displayValue = React.useMemo(() => {
    switch (variant) {
      case "number":
        return String(value);

      case "time": {
        const time = Utils.Helpers.getHours(value);
        return `${time.h}:${time.m}`;
      }
    }
  }, [value, variant]);

  return (
    <Stack
      spacing={1}
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      <IconButton disabled={value === minValue} onClick={onReduce}>
        <RemoveCircleOutline />
      </IconButton>
      <Typography style={{ userSelect: "none" }}>{displayValue}</Typography>
      <IconButton disabled={value === maxValue} onClick={onIncrease}>
        <AddCircleOutline />
      </IconButton>
    </Stack>
  );
};
